// Translation: Error > Landing > Message (Turkish)
export default Object.freeze({
	fallback: {
		title: 'Sayfa bulunamadı'
	}
})
